import React, { useEffect, useState } from "react";
import { imgrepeat } from "../image";
import "./loading.css";
import { MutatingDots } from "react-loader-spinner";

const Spinner2 = ({ progress = 100, onComplete }) => {
  const safeProgress = Math.max(0, Math.min(100, Number(progress) || 0));
  const [displayProgress, setDisplayProgress] = useState(safeProgress);
  const [completedNotified, setCompletedNotified] = useState(false);
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const root = document.documentElement;
    const updateTheme = () => setIsDark(root.classList.contains("dark"));
    updateTheme();

    const observer = new MutationObserver(updateTheme);
    observer.observe(root, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let rafId;
    const animate = () => {
      setDisplayProgress((prev) => {
        const diff = safeProgress - prev;
        if (Math.abs(diff) < 0.1) return safeProgress;
        return prev + diff * 0.14;
      });
      rafId = requestAnimationFrame(animate);
    };
    rafId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafId);
  }, [safeProgress]);

  const roundedProgress = Math.round(displayProgress);

  useEffect(() => {
    if (roundedProgress >= 100 && !completedNotified) {
      setCompletedNotified(true);
      onComplete?.();
    }
    if (roundedProgress < 100 && completedNotified) {
      setCompletedNotified(false);
    }
  }, [roundedProgress, completedNotified, onComplete]);

  return (
    <div className={`crazy-loader-screen ${isDark ? "mode-dark" : "mode-light"}`}>
      <div className="crazy-bg-orb orb-one" />
      <div className="crazy-bg-orb orb-two" />
      <div className="crazy-bg-orb orb-three" />

      <div className="crazy-loader-card">
        <div className="crazy-rings" aria-hidden="true">
          <span className="ring ring-one" />
          <span className="ring ring-two" />
          <span className="ring ring-three" />
        </div>

        <img
          src={isDark ? imgrepeat.logo_white : imgrepeat.logo_green}
          alt="RepeatConnect"
          className="crazy-logo"
        />

       {/*  <div role="status" className="mt-3 flex justify-center">
          <MutatingDots
            visible={true}
            height="92"
            width="92"
            color={isDark ? "#00d09c" : "#009c7a"}
            secondaryColor={isDark ? "#20e3b2" : "#00c39a"}
            radius="12.5"
            ariaLabel="mutating-dots-loading"
            wrapperStyle={{}}
            wrapperClass="z-10"
          />
          <span className="sr-only">Loading...</span>
        </div> */}


        <div className="mt-12 crazy-progress-track">
          <div
            className="crazy-progress-fill"
            style={{ width: `${displayProgress}%` }}
          />
          <div className="crazy-progress-glow" style={{ width: `${displayProgress}%` }} />
          <div className="crazy-progress-label">
            {roundedProgress}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spinner2;
